import React, { useState, useEffect } from 'react';
import Offline from 'pages/errors/Offline';

import Routes from '../../routes';

function CheckConnection() {
  const [isOnline, setIsOnline] = useState(window.navigator.onLine);

  useEffect(() => {
    // Função para atualizar o estado com o status atual da conexão.
    const atualizarStatusConexao = () => {
      setIsOnline(window.navigator.onLine);
    };

    // Adiciona os ouvintes para detectar mudanças na conexão.
    window.addEventListener('online', atualizarStatusConexao);
    window.addEventListener('offline', atualizarStatusConexao);

    // Remove os ouvintes quando o componente é desmontado para evitar vazamentos de memória.
    return () => {
      window.removeEventListener('online', atualizarStatusConexao);
      window.removeEventListener('offline', atualizarStatusConexao);
    };
  }, []);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{isOnline ? <Routes /> : <Offline />}</>
  );
}

export default CheckConnection;
